import * as React from 'react';
import { ProfileModel } from '../../../core/models/ProfileModel';
import { ListItemWidget, MetaItem } from './ListItemWidget';
import { useSystem } from '../../../hooks/useSystem';
import { observer } from 'mobx-react';
import { faDog } from '@fortawesome/free-solid-svg-icons';
import { useEffect } from 'react';

export interface ProfileListItemWidgetProps {
  profile: ProfileModel;
  meta?: MetaItem[];
  action?: () => any;
}

export const ProfileListItemWidget: React.FC<ProfileListItemWidgetProps> = observer((props) => {
  const system = useSystem();
  let is_friend = system.user.isFriend(props.profile);

  useEffect(() => {
    props.profile.refresh();
  }, [props.profile]);

  let meta: MetaItem[] = [...(props.meta || [])];
  if (is_friend) {
    meta.push({
      label: 'Friend'
    });
  }
  if (system.user.id.equals(props.profile.id)) {
    meta.push({
      label: 'ME!'
    });
  }

  return (
    <ListItemWidget
      action={props.action}
      media={{
        image: props.profile.image,
        icon: faDog
      }}
      label={props.profile.data?.profile_name}
      meta={meta}
    />
  );
});
